import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import ModalBasic from '../components/ModalBasic';
import SignupForm from '../components/SignupForm';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../userContext';

const SignupModalContext = createContext({ openSignupModal: () => {} });

export function useSignupModal() {
    return useContext(SignupModalContext);
}

// Wraps landing-style pages so any descendant CTA can open a single shared
// signup modal via useSignupModal(). If the visitor is already signed in we
// skip the modal entirely and send them straight into the studio - no point
// asking someone to sign up when they already have an account.
export function SignupModalProvider({ children }) {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { user, userProfile } = useUser();

    const openSignupModal = useCallback(() => {
        if (user) {
            const target = userProfile?.onboardingComplete === false
                ? '/studio/setup'
                : '/studio/dashboard';
            navigate(target);
            return;
        }
        setOpen(true);
    }, [user, userProfile, navigate]);

    const value = useMemo(() => ({ openSignupModal }), [openSignupModal]);

    return (
        <SignupModalContext.Provider value={value}>
            {children}
            <ModalBasic id="landing-signup-modal" title="Create your account" modalOpen={open} setModalOpen={setOpen}>
                <div className="p-5 sm:p-6">
                    <SignupForm
                        compact
                        showHero={false}
                        onSuccess={() => {
                            setOpen(false);
                            navigate('/studio/setup', { replace: true, state: { fromSignup: true } });
                        }}
                    />
                </div>
            </ModalBasic>
        </SignupModalContext.Provider>
    );
}
